import { Accordion } from '@/types';
import AccordionsComponent from '@components/Accordions';

interface Props {
  accordions: Accordion[];
  blocktitle?: string;
}

function createUrlString(value: string) {
  const replacedValue = value
    .toLowerCase()
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/ß/g, 'ss')
    .replace(/[\s.,()]/g, '');

  return replacedValue;
}

function Accordions(props: Props) {
  const { accordions, blocktitle } = props;

  return (
    <div className='streamfield accordions' id={createUrlString(blocktitle || 'accordion')}>
      {blocktitle ? <h2 className='accordions__header'>{blocktitle}</h2> : ''}

      <AccordionsComponent accordions={accordions} />
    </div>
  );
}

export default Accordions;
